module.exports = __webpack_public_path__ + "img/noI_leaf_beryl.06fbbe71.png";